import React from "react";
import { YHModal } from "@/components/YHModal";
import { YhBox } from "@/components/YhBox";
import { Table, message } from "antd";
import { ColumnsType } from "antd/lib/table";
import { useSaleSoModel } from "../../saleSoModel";
import { ISCMSaleSoDetail } from "../../saleSoTypes";
import { YhBut } from "@/components/YhButton";
import { saleSoService } from "../../saleSoService";
import { useLockFn } from "ahooks";
import useGlobalModel from "@/model/globalModel";

export const WhConfirmModal = () => {
    const { confirmModal: visible, setConfirmModal, descRows, selectedRowKeys, setDescRows, setSelectedRowKeys, loadData } = useSaleSoModel();
    const { shopAndOrg: { shopCode }, user } = useGlobalModel()

    const onCancel = () => {
        setConfirmModal(false);
    };


    const columns: ColumnsType<any> = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            align: "center",
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '销售单号',
            width: 180,
            align: "center",
            dataIndex: 'saleCode',
        }, {
            title: '销售数量',
            width: 120,
            align: "center",
            dataIndex: 'totalNum',
        },
        {
            title: '操作',
            width: 80,
            fixed: "right",
            align: "center",
            className: "td-wrap",
            render: (text: any, record: any) =>
                <YhBut
                    type="delete"
                    txt="删除"
                    click={() => {
                        descRows.length === 1 && onCancel();
                        setDescRows(origin => origin.filter(item => item.id !== record.id));
                    }}
                />
        }
    ];

    const onSubmit = useLockFn(async () => {
        let params: any = []
        descRows.map((item) => {
            params.push({
                id: item.id,
                saleCode: item.saleCode,
                storekeeper: user.username,
            })
        })
        let { retData } = await saleSoService.someSettle(params);
        if (retData) {
            message.success('出库成功')
            onCancel()
            loadData()
        }
    })

    return <YHModal
        visible={visible}
        onOk={onSubmit}
        onCancel={onCancel}
        title="出库"
        width={'60%'}
        bodyHeight={500}
        showFooter={true}
    >
        {visible && <YhBox style={{ marginBottom: "15px" }}>
            <Table
                bordered
                rowKey={record => record.id}
                columns={columns}
                dataSource={descRows}
                pagination={false}
                scroll={{ x: 'max-content', y: 400 }}
            />
        </YhBox>}
    </YHModal>
}